module.exports = __webpack_public_path__ + "static/media/sheet-01-md.90778178.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sheet-01-md.jpeg
// module id = 573
// module chunks = 0